import {HttpRequest} from '../Data/HttpRequest'
import {server} from '../Data/BuildEnvironment'
import {buildUrl} from '../Data/Http'

export function listForCustomer(
    manufacturerId: number,
    customerId: number,
    search: string,
): HttpRequest {
    return {
        verb: 'GET',
        url:
            buildUrl(
                `${server}/manufacturers/${manufacturerId}/customers/${customerId}/products`,
                {limit: '12', search},
            ),
        headers: {
            'Accept': 'application/json',
        },
    }
}

export function listSuggestionsForCustomerWithPriceDefinitions(
    manufacturerId: number,
    customerId: number,
    search: string,
): HttpRequest {
    return {
        verb: 'GET',
        url:
            buildUrl(
                `${server}/manufacturers/${manufacturerId}/customers/${customerId}/product-with-price-definitions`,
                {limit: '12', search}),
        headers: {
            'Accept': 'application/json',
        },
    }
}

export function downloadPrintPdf(id: number): HttpRequest {
    return {
        verb: 'GET',
        url: `${server}/products/${id}/print-pdf`,
        headers: {},
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Request/ProductResource.ts